import styled from 'styled-components';
import { TransitionProps } from './transition.types';

export const Container = styled.div<{
  show: TransitionProps['show'];
}>`
  @keyframes mount {
    0% {
      opacity: 0;
      transform: translateY(6px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }

  @keyframes unmount {
    0% {
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateY(6px);
    }
  }

  animation-name: ${({ show }) => (show ? 'mount' : 'unmount')};
  animation-duration: 150ms;
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`;
